export default __webpack_public_path__ + "static/media/order_pay.d180d3c9.svg";